import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { RButtonIcon } from 'components/ui/RButtonIcon';
import { MESSAGE_SVG, TABLE_CHEVRON_SVG } from 'components/ui/_shared/SVG';
import { useToggle } from 'hooks/useToggle';
import { APP_ROUTES } from 'router/appRoutes';
import { MessageSelectorPopup } from 'pages/User/_shared/MessageSelectorPopup';
import { dancers } from 'store/dancers';
import { ActionsCellWrapperStyled } from './styled';
import { onStopPropagation } from '../../../../../../utils/prevent-events';

export function ActionsCell({ row }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [showPopup, toggleShowPopup] = useToggle(false);

  const onMessageClick = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPopupPosition({ y: rect.top, x: rect.left });
    toggleShowPopup();
  };
  const onModalClose = () => toggleShowPopup();

  const onChevronClick = () => {
    navigate(APP_ROUTES.user.dancers.details.index.replace(':id', row.id));
  };

  const onSubmitSms = async (data) => {
    try {
      await dispatch(dancers.thunks.sendSms(data)).unwrap();
    } catch (err) {
      console.error(err);
    }
  };

  const onSubmitEmail = async (data) => {
    try {
      await dispatch(dancers.thunks.sendEmail(data)).unwrap();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ActionsCellWrapperStyled onClick={(e) => onStopPropagation(e)}>
      <RButtonIcon onClick={onMessageClick}>
        <MESSAGE_SVG />
      </RButtonIcon>

      <RButtonIcon onClick={onChevronClick}>
        <TABLE_CHEVRON_SVG />
      </RButtonIcon>

      {showPopup && (
        <MessageSelectorPopup
          recipients={[
            {
              label: row.primary_contact_full_name,
              value: row.primary_contact_id,
            },
          ]}
          onClose={onModalClose}
          position={popupPosition}
          onSubmitSms={onSubmitSms}
          onSubmitEmail={onSubmitEmail}
          emptyContacts
          disableAdding
          prepareRecipientsOnSubmit
        />
      )}
    </ActionsCellWrapperStyled>
  );
}

ActionsCell.propTypes = {
  row: PropTypes.object,
};
